export default __webpack_public_path__ + "static/media/Bell.cb781b46.svg";